/** The `$orderId` path param reaches the page as `router.query.orderId`; an unknown id renders the page's "not found" state in place. */
import { createFileRoute } from '@tanstack/react-router'

import RaChangePage from '@/features/registered-agent/pages/ra-change'

export const Route = createFileRoute('/_shell/registered-agent/change/$orderId')({ component: RaChangePage })
